import {Component, HostBinding, Input} from '@angular/core';
import {SvgIconComponent} from "angular-svg-icon";
import {NgIf} from "@angular/common";
import {XLabelPaddingComponent} from "../x-label-padding/x-label-padding.component";

@Component({
  selector: 'app-x-search-list-item',
  standalone: true,
  imports: [SvgIconComponent, NgIf, XLabelPaddingComponent],
  templateUrl: './x-search-list-item.component.html',
  styleUrl: './x-search-list-item.component.less',
})
export class XSearchListItemComponent {
  @HostBinding('class') @Input() type: 'single' | 'stacked' = 'single';
  @HostBinding('class.with_hover') @Input() withHover: boolean = false;
  @HostBinding('class.selected') @Input() selected: boolean = false;
  @Input() iconName: string = '';
  @Input() singleText: string = '';
  @Input() stackedTextTitle: string = '';
  @Input() stackedTextSubtitle: string = '';
  @Input() breadcrumb: string = '';

  // Inline style fallback for "selected" state (keeps it robust even if stylesheets differ in line-endings).
  @HostBinding('style.background') get selectedBackground(): string | null {
    return this.selected ? 'var(--Accent-Blue, #18A0FB)' : null;
  }

  @HostBinding('style.cursor') get selectedCursor(): string | null {
    return this.selected ? 'pointer' : null;
  }

  @HostBinding('style.color') get selectedIconColor(): string | null {
    return this.selected ? '#FFFFFF' : null;
  }

  // Override internal text colors via CSS variables used in the component stylesheet.
  @HostBinding('style.--Basic-Black-8') get selectedPrimaryTextColor(): string | null {
    return this.selected ? '#FFFFFF' : null;
  }

  @HostBinding('style.--Basic-Black-3') get selectedSecondaryTextColor(): string | null {
    return this.selected ? '#FFFFFF' : null;
  }
}
